var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.73c1.392 0 3.217.03 4.69.182.54.056 1.011.096 1.442.272v-.001a3.05 3.05 0 0 1 1.748 1.945l.042.17c.085.4.078.837.078 1.335a1 1 0 0 1-2 0c0-.695-.01-.84-.041-.946a1.05 1.05 0 0 0-.584-.653c-.1-.041-.23-.065-.889-.133-1.051-.108-2.325-.15-3.486-.165v16.245h2a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1 0-1.5h2V4.736c-1.162.014-2.435.057-3.487.165-.659.068-.788.091-.888.132-.269.11-.501.368-.584.654-.031.107-.041.25-.041.946a1 1 0 0 1-2 0c0-.569-.01-1.058.12-1.505a3.05 3.05 0 0 1 1.746-1.945c.43-.177.903-.215 1.443-.27C8.782 2.76 10.608 2.73 12 2.73"
  })));
};
export default Svg24;